import React, { useEffect, useState } from "react";

import { RobotButton, UnreadBadge, Wrap } from "./styles";
import { RootState } from "store/store";
import { useDispatch } from "react-redux";
import { Spin } from "antd";
import { setSelectedRobot } from "store/reducers/RobotsSlice";
import { UnreadData } from "components/WsRobotsUnreadHandler/WsRobotsUnreadHandler";
import { useAppSelector } from "hooks/redux";
type RobotMode = "full" | "partial" | "ok";
function RobotsList() {
    const { robots, selectedRobotId, robotStatuses } = useAppSelector(
        (state: RootState) => state.robots,
    );
    const { loggedIn } = useAppSelector((state: RootState) => state.auth);
    
    const dispatch = useDispatch();

    const [unreadMap, setUnreadMap] = useState<Record<string, UnreadData>>({});

    useEffect(() => {
        if(!loggedIn) return;
        const handleUnreadUpdate = (e: CustomEvent<UnreadData[]>) => {
            const items = e.detail;
            const newMap: Record<string, UnreadData> = {};
            items.forEach((item) => {
                newMap[item.robot_id] = item;
            });
            setUnreadMap(newMap);
        };

        window.addEventListener(
            "robots_unread_update",
            handleUnreadUpdate as EventListener,
        );

        return () => {
            window.removeEventListener(
                "robots_unread_update",
                handleUnreadUpdate as EventListener,
            );
        };
    }, [loggedIn]);
    if (!loggedIn) return null;
    if (!robots || robots.length === 0) {
        return (
            <Wrap>
                <Spin />
            </Wrap>
        );
    }
    return (
        <Wrap>
            {robots.map((robot) => {
                const isActive = robot.robot_id === selectedRobotId;
                const statusInfo = robotStatuses[robot.robot_id];

                const mode: RobotMode | undefined = statusInfo?.mode;
                let circleColor = "#4caf50";

                if (mode === "full") {
                    circleColor = "#f44336";
                } else if (mode === "partial") {
                    circleColor = "#8bc34a";
                } else if (mode === "ok") {
                    circleColor = "#4caf50";
                }

                const unread = unreadMap[robot.robot_id];
                const totalUnreadAll = unread?.total_unread || 0;
                return (
                    <div
                        key={robot.robot_id}
                        style={{
                            position: "relative",
                            display: "inline-block",
                        }}
                    >
                        {" "}
                        <RobotButton
                            $isActive={isActive}
                            key={robot.robot_id}
                            onClick={() =>
                                dispatch(setSelectedRobot(robot.robot_id))
                            }
                            style={{ border: `1px solid ${circleColor}` }}
                        >
                            {robot.name}
                        </RobotButton>
                        {totalUnreadAll > 0 && (
                            <UnreadBadge
                                color={circleColor}
                                style={{ background: circleColor }}
                            >
                                {totalUnreadAll > 99 ? "99+" : totalUnreadAll}
                            </UnreadBadge>
                        )}
                    </div>
                );
            })}
        </Wrap>
    );
}

export default RobotsList;
